import { render, staticRenderFns } from "./simple-head.vue?vue&type=template&id=64a9cb00&scoped=true&"
import script from "./simple-head.vue?vue&type=script&lang=js&"
export * from "./simple-head.vue?vue&type=script&lang=js&"
import style0 from "./simple-head.vue?vue&type=style&index=0&id=64a9cb00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a9cb00",
  null
  
)

export default component.exports